/**
* Error Page JS
* -----------------------------------------------------------------------------
*
* All the JS for the Error Page component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'error-page',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      this.animateLogo();
    },

    animateLogo: function() {
      const logo = document.querySelector( '.error-page .error-page__img' );

      if ( logo ) {
        gsap.fromTo( logo,
            {
              scale: 0,
            },
            {
              scale: 1.5,
              duration: 0.5,
              ease: 'power2.out',
              yoyo: true,
              repeat: 1,
              onComplete: () => {
                gsap.set( logo, {scale: 1} );
              },
            },
        );
      } else {
        console.error( 'Logo element not found' );
      }
    },

    finalize: function() {},
  };

  app.registerComponent( 'error-page', COMPONENT );
} )( app );
